import { render } from "./Wiki-Women.vue?vue&type=template&id=74ed08ad&scoped=true"
import script from "./Wiki-Women.vue?vue&type=script&lang=js"
export * from "./Wiki-Women.vue?vue&type=script&lang=js"

import "./Wiki-Women.vue?vue&type=style&index=0&id=74ed08ad&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ed08ad"]])

export default __exports__